import { SET_AUTH_DATA, SET_USER, SIGN_OUT } from "./types";
import { apiCall } from "../../components/Services/Interceptor";
import loginService from "../../components/Services/login.service";
import roleAccessService from "../../components/Services/roleAccess.service";
import { RESET_CON_CAPACITY } from "../ConsumerCapacity/types";
import { RESET_GEN_CAPACITY } from "../Capacity/types";
import { GetTokens } from "../../firebase";

const menuData = {
  GENERATOR: [
    {
      path: "/dashboard",
    },
    {
      path: "/generator_capacity",
    },
    {
      path: "/company_profile",
    },
    {
      path: "/my_documents",
    },
    {
      path: "/capacity_listing",
    },
    {
      path: "/edit_profile",
    },
    {
      path: "/bids_received",
    },
    {
      path: "/faqs",
    },
    {
      path: "/capacity_listing",
    },
    {
      path: "/search_listings",
    },
  ],
  CONSUMER: [
    {
      path: "/consumer_dashboard",
    },
    {
      path: "/generator_capacity",
    },
    {
      path: "/company_profile",
    },
    {
      path: "/my_documents",
    },
    {
      path: "/capacity_listing",
    },
    {
      path: "/edit_profile",
    },
    {
      path: "/bids_received",
    },
    {
      path: "/faqs",
    },
    {
      path: "/search_listings",
    },
  ],
  ANALYST: [
    {
      path: "/analyst_dashboard",
    },
    {
      path: "/analyst_edit_profile",
    },
    {
      path: "/analyst_registration",
    },
    {
      path: "/analyst_capacity_listing",
    },
    {
      path: "/user_profile",
    },
    {
      path: "/upload_sheet",
    },
  ],
  COMPANY_ADMIN: [
    {
      path: "/admin_comp_dashboard",
    },
    {
      path: "/admin_comp_userProfile",
    },
  ],
  TRADER: [
    {
      path: "/trader_dashboard",
    },
  ],
  BANKING: [
    {
      path: "/banking",
    },
    {
      path: "/bankingRequests_received",
    },
    {
      path: "/my_documents",
    },
    {
      path: "/capacity_listing",
    },
    {
      path: "/edit_profile",
    },
    {
      path: "/banking_ledger",
    },
    {
      path: "/search_banking",
    },
    {
      path: "/company_profile",
    },
  ],
};
export const signIn = (data, navigate) => async (dispatch) => {
  await apiCall
    .post("/auth/login", data)
    .then((response) => {
      if (response && response.data.code === 200) {
        let menu = menuData?.[response.data?.data?.activeRole];
        if (response.data?.data?.isVerified === true) {
          dispatch({
            type: SET_AUTH_DATA,
            payload: {
              role: response.data?.data?.activeRole,
              token: response.data?.data?.token,
              menuData: menu,
              companyDisplayName: response?.data?.data?.companyDisplayName,
              companyName: response?.data?.data?.companyName,
              connectionName: response?.data?.data?.config,
              isVerified: response?.data?.data?.isVerified,
              activeRoleId: response?.data?.data?.activeRoleId,
              userName: response?.data?.data?.username,
            },
          });
          //get available roles for the logged in user
          getCompanyList()(dispatch);
          let data;
          async function tokenFunc() {
            data = await GetTokens();
            return data;
          }
          tokenFunc();
          //set menu data
          localStorage.setItem("ROLE", response?.data?.data.activeRole);
          localStorage.setItem("TOKEN_ACCESS", response?.data?.data.token);
          localStorage.setItem("CONNECTION_NAME", response?.data?.data?.config);
          response?.data?.data.activeRole !== "ANALYST" &&
            localStorage.setItem("FIRST_LOGIN", true);
          menu[0]?.path && navigate(menu[0]?.path);
        } else {
          navigate("/account_verification");
        } // redirect to dashboard
      }
    })
    .catch((err) => console.log(err));
};

export const logout = () => async (dispatch) => {
  const deviseToken = localStorage.getItem("DEVISE_TOKEN");
  await loginService
    .logoutFirebaseToken(deviseToken)
    .then((response) => {
      if (response?.data?.code === 200) {
        console.log("Token Sent successfully on Logout");
      }
    })
    .catch((err) => console.log(err));
  window.location.replace("/");
  localStorage.clear();
  sessionStorage.clear();
  const pageLoadPromise = new Promise((resolve) => {
    window.onload = resolve;
  });
  // Wait for the page to load
  await pageLoadPromise;
  dispatch({ type: SIGN_OUT, payload: false });
};
export const roleSelection = (companyRoleId, navigate) => async (dispatch) => {
  await apiCall
    .post(`auth/switch-login?companyRoleId=${companyRoleId}`)
    .then((response) => {
      if (response && response.data.code === 200) {
        let menu = menuData?.[response.data?.data?.activeRole];
        dispatch({
          type: SET_AUTH_DATA,
          payload: {
            role: response.data?.data?.activeRole,
            token: response.data?.data?.token,
            menuData: menu,
            companyDisplayName: response?.data?.data?.companyDisplayName,
            companyName: response?.data?.data?.companyName,
            connectionName: response?.data?.data?.config,
            isVerified: response?.data?.data?.isVerified,
            activeRoleId: response?.data?.data?.activeRoleId,
            userName: response?.data?.data?.username,
          },
        });
        dispatch({ type: RESET_CON_CAPACITY });
        dispatch({ type: RESET_GEN_CAPACITY });
        //set menu data
        localStorage.setItem("ROLE", response?.data?.data.activeRole);
        localStorage.setItem("TOKEN_ACCESS", response?.data?.data.token);
        localStorage.setItem("CONNECTION_NAME", response?.data?.data?.config);
        menu[0]?.path && navigate(menu[0]?.path); // redirect to dashboard
      }
    })
    .catch((err) => console.log(err));
};

export const getCompanyList = () => async (dispatch) => {
  roleAccessService
    ?.getAllcompanyList()
    .then((res) => {
      if (res?.data?.code === 200) {
        dispatch({
          type: SET_USER,
          payload: res?.data?.data,
        });
      }
    })
    .catch((err) => console.log(err));
};
